type ListItemProps = { item: string };

const ListItem = ({ item }: ListItemProps) => (
  <li className="font-medium">{item}</li>
);

export default ListItem;
